/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserInfoResponse } from '../models/UserInfoResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticationService {
    /**
     * Initiate OIDC login
     * Redirect to Authentik authorization endpoint to start OAuth flow
     * @returns any Successful Response
     * @throws ApiError
     */
    public static loginAuthLoginGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/login',
            errors: {
                401: `Authentication failed`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * OAuth callback handler
     * Handle OAuth callback from Authentik, exchange code for tokens, create session
     * @returns any Successful Response
     * @throws ApiError
     */
    public static callbackAuthCallbackGet({
        code,
        state,
    }: {
        /**
         * Authorization code from Authentik
         */
        code: string,
        /**
         * OAuth state parameter
         */
        state?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/callback',
            query: {
                'code': code,
                'state': state,
            },
            errors: {
                401: `Authentication failed`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Logout user
     * Clear session cookies and logout user
     * @returns any Successful Response
     * @throws ApiError
     */
    public static logoutAuthLogoutPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/logout',
            errors: {
                401: `Authentication failed`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get current user
     * Get current authenticated user information from session
     * @returns UserInfoResponse Successful Response
     * @throws ApiError
     */
    public static getCurrentUserAuthMeGet({
        session,
    }: {
        session?: (string | null),
    }): CancelablePromise<UserInfoResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/me',
            cookies: {
                'session': session,
            },
            errors: {
                401: `Authentication failed`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
}
